import { useMatchPath } from "./useMatchPath";


export const useProjectPath = () => {
  
  return useMatchPath<{clientId: string; projectId: string}>("/clients/:clientId/projects/:projectId");
}